// import { BaseQueryArg } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { ICategory } from '../../model/ICategory';
import api from './api';

export const magentoApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<ICategory[], unknown>({
      query: () => ({
        url: '/magento/categories',
      }),
      // -- Root Category -> Default Category
      transformResponse: (response: any, meta, arg) => {        
        return response?.children_data?.[0]?.children_data;
      }
    }),
    isServerAvailable: build.query<{ isServerAvailable: boolean }, unknown>({
      query: () => ({
        url: '/magento/is-available',
      }),      
    }),
  }),
});
